import { RouteLocationNormalized } from 'vue-router'
import { Person } from '@/api/entities/people/types'

export enum LlmModel {
  AMAZON_NOVA_LITE = 'AMAZON_NOVA_LITE',
  AMAZON_NOVA_MICRO = 'AMAZON_NOVA_MICRO',
  AMAZON_NOVA_PRO = 'AMAZON_NOVA_PRO',
  CLAUDE_SONNET_4_5 = 'CLAUDE_SONNET_4_5',
  CLAUDE_SONNET_4 = 'CLAUDE_SONNET_4',
  CLAUDE_HAIKU_4_5 = 'CLAUDE_HAIKU_4_5',
  LLAMA_3_3 = 'LLAMA_3_3',
}

export type GenericLlmRequest = {
  query: string
  system?: string
  temperature?: number
  maxResponseTokens?: number
  model?: LlmModel
  debug?: boolean
}

export type LlmResponseMetadata = {
  fullResponse: string
  model: LlmModel
  finalPrompt: string
  systemPrompt: string
  numInputTokens: number | null
  numOutputTokens: number | null
  cost: number | null
}

export type GenericLlmResponse = {
  response: string
  rawLogId: string
  metadata?: LlmResponseMetadata
}

export enum LlmSourceType {
  COMMUNICATION = 'COMMUNICATION',
  CLAIM = 'CLAIM',
  SUBTASK = 'SUBTASK',
  GOAL = 'GOAL',
  CARE_PLAN = 'CARE_PLAN',
  PROFILE = 'PROFILE',
  CLINICAL_SUMMARY = 'CLINICAL_SUMMARY',
}

export type ValidatedQuote = {
  quote: string
  fieldName: string
}

export type CitedContextDatapoint = {
  sourceId: string
  sourceType: LlmSourceType
  sourceSubtype?: string
  displayTitle?: string
  displayTimestamp?: string
  validatedQuotes: ValidatedQuote[]
  relevanceScore?: number
}

export type LlmToolCall = {
  toolName: string
  args?: { [key: string]: any }
}

export type AskAProfileResponse = GenericLlmResponse & {
  citations: CitedContextDatapoint[]
  tools: LlmToolCall[]
}

export type RecommendedArticlesResponse = {
  selectedArticles: RecommendedArticle[]
}

export type RecommendedArticle = {
  title: string
  confidence: number
  source: string
  rationale: string
}

export type KnowledgeBaseSourceDocument = {
  responseLocation: [number, number]
  documentName: string
  documentId: string
  relevantContent: string
}

export type KnowledgeBaseLlmResponse = {
  sourceDocuments: KnowledgeBaseSourceDocument[]
} & GenericLlmResponse

export enum LlmDatadogLogEvent {
  QUERY = 'llmQuery',
  COARSE_FEEDBACK = 'llmFeedbackCoarse',
  GRANULAR_FEEDBACK = 'llmFeedbackGranular',
  CUSTOM_FEEDBACK = 'llmFeedbackCustom',
}

export enum LlmFeature {
  LEGACY_ASK_A_PROFILE = 'legacyAskAProfile',
  ASK_A_PROFILE = 'askAProfile',
  ASK_THYME_BOX = 'askThymeBox',
  THYMELINE_SUMMARIES = 'thymelineSummaries',
}

export type LlmDatadogLoggingDetails = {
  rawLogId: string
  route: RouteLocationNormalized
  feature: LlmFeature
  // Logging the query is optional in case we don't want to log it for privacy reasons
  query?: string
  // Logging the response is optional in case we don't want to log it for privacy reasons
  response?: string
  // Staff member details
  person: Person | undefined
  roles: string[]
  // Additional metadata
  model?: LlmModel
  temperature?: number
  maxResponseTokens?: number
  sourceDocuments?: string[]
  // Any additional custom properties can also be included
} & { [key: string]: any }
